import { render, staticRenderFns } from "./DashboardEstimage.vue?vue&type=template&id=8a85e8d2&scoped=true"
import script from "./DashboardEstimage.vue?vue&type=script&lang=js"
export * from "./DashboardEstimage.vue?vue&type=script&lang=js"
import style0 from "./DashboardEstimage.vue?vue&type=style&index=0&id=8a85e8d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a85e8d2",
  null
  
)

export default component.exports